import { Link } from 'react-router-dom';
import Reveal from '../ui/Reveal';
import { ArrowRight } from '../ui/Icons';

const SHADES = [
  { name: 'Terracotta Clay', hex: '#B5452F' },
  { name: 'Warm Linen', hex: '#EFE7D6' },
  { name: 'Marigold', hex: '#F2B632' },
  { name: 'Leaf Green', hex: '#5E7B4C' },
  { name: 'Oak Buff', hex: '#D2B48C' },
];

/**
 * Full-bleed, two-panel feature: a room photograph on one half and a panel
 * painted in the featured shade on the other, with the copy in a card that
 * straddles the seam.
 */
const ColourOfSeason = () => (
  <section className="relative bg-[#B5452F]">
    <div className="grid lg:grid-cols-2">
      {/* Photo half */}
      <div className="relative h-[380px] sm:h-[480px] lg:h-[640px] overflow-hidden">
        <img src="/images/web/room-red.jpg" alt="A living room with a terracotta feature wall and a yellow sofa" loading="lazy" className="absolute inset-0 w-full h-full object-cover vp-pan" />
        <span className="absolute top-6 left-6 vp-chip vp-chip-gold px-4 py-2 text-sm shadow-gold">Colour of the season</span>
      </div>

      {/* Colour half */}
      <div className="relative flex items-center px-5 sm:px-10 lg:px-16 py-14 lg:py-0 text-white">
        <div className="pointer-events-none absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_80%_20%,#fff_0,transparent_45%)]" />
        <Reveal className="relative max-w-lg lg:-ml-40 xl:-ml-48">
          <div className="bg-white text-brand-ink rounded-3xl shadow-lift p-7 sm:p-9">
            <span className="vp-eyebrow">Colour of the season</span>
            <h2 className="vp-heading mt-4 text-3xl sm:text-4xl">Terracotta Clay</h2>
            <p className="mt-4 text-brand-muted leading-relaxed">
              An earthy, sun-baked red that makes a living room feel warm and grounded. Pair it with soft linen on the remaining walls and a brass or
              marigold accent for a scheme that works in both daylight and lamplight.
            </p>
            <div className="mt-6 grid grid-cols-5 gap-2">
              {SHADES.map((s) => (
                <div key={s.hex} className="text-center">
                  <span className="block aspect-square rounded-xl border border-black/5 shadow-soft" style={{ background: s.hex }} />
                  <span className="block mt-1.5 text-[10px] sm:text-[11px] font-medium text-brand-muted leading-tight">{s.name}</span>
                </div>
              ))}
            </div>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/colours/combinations" className="vp-btn vp-btn-primary">
                See the palette
                <ArrowRight />
              </Link>
              <Link to="/sample-request" className="vp-btn vp-btn-outline">
                Order a sample
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default ColourOfSeason;
